import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { mediaUrl } from "@/lib/api";
import { pickSource } from "@/features/player/sourceLoader";

export const TrailerModal = ({ title, open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="trailer-modal"
      className="max-w-5xl w-[94vw] p-0 overflow-hidden bg-black border border-[#D4AF37]/35 shadow-[0_0_80px_rgba(212,175,55,0.18)] [&>button]:hidden"
    >
      <DialogTitle className="sr-only">{title?.title} trailer</DialogTitle>
      <div className="flex items-center justify-between px-5 py-3 border-b border-[#D4AF37]/20">
        <span className="eyebrow">Official Trailer · <span className="text-white">{title?.title}</span></span>
        <button data-testid="trailer-close-btn" onClick={() => onOpenChange(false)} className="text-white/70 hover:text-[#FFD86A] transition-colors" aria-label="Close trailer">
          <X className="h-5 w-5" />
        </button>
      </div>
      {open && title?.trailer_url && (
        <video data-testid="trailer-video" src={mediaUrl(pickSource(title.trailer_url, title.alt_trailer_urls))} poster={title.backdrop_url} controls autoPlay playsInline className="w-full aspect-video bg-black" />
      )}
    </DialogContent>
  </Dialog>
);
